import React from 'react';
import styles from 'dashboard/Dashboard.scss';
import buildAccountSidebar from './SidebarBuilder';

const DefaultView = (props) => {
  return (
    <div className={styles.dashboard}>
      <div className={styles.content}>{props.children}</div>
      {
        props.currentUser && props.currentUser.id &&
        buildAccountSidebar({
          section: props.section,
          subsection: props.subsection,
          currentUser: props.currentUser,
          currentCustomer: props.currentCustomer,
        })
      }
    </div>
  );
};

export default DefaultView;
